import { CommonModule } from "@angular/common";
import { Component, input } from "@angular/core";

import { StatsCardComponent } from "@shared/components/stats-card/stats-card.component";

export interface StatItem {
  value: string | number;
  label: string;
  variant?: "primary" | "golden";
}

@Component({
  selector: "app-entity-overview",
  imports: [CommonModule, StatsCardComponent],
  templateUrl: "./entity-overview.component.html",
  styleUrls: ["./entity-overview.component.scss"],
})
export class EntityOverviewComponent {
  title = input<string>("Overview");
  stats = input.required<StatItem[]>();
}
